import { c as _c } from "react/compiler-runtime";
import { useStore } from 'zustand';
import type { KeyboardLike, KeyWith } from '@/lib/piano/keyboard';
import type { MeasuredKeyRequirements } from '@/lib/piano/touch-design/measured-key.requirements';
import { useMemo } from 'react';
import { useShallow } from 'zustand/shallow';
import { useKeyboard } from './use-keyboard';
import { useMeasuresStore, type MeasuresStore } from '../store/use-measure-store';
import { useKeyMeasurementsHelpers } from './use-key-measurements-helpers';
export const useMeasuredKeyboard = () => {
  const $ = _c(7);
  const {
    computeKeyMeasurements
  } = useKeyMeasurementsHelpers();
  const pianoMeasureState = useStore(useMeasuresStore(), useShallow(_temp));
  const {
    keyboard
  } = useKeyboard();
  let t0;
  if ($[0] !== computeKeyMeasurements || $[1] !== keyboard || $[2] !== pianoMeasureState) {
    let t1;
    if ($[4] !== computeKeyMeasurements || $[5] !== pianoMeasureState) {
      t1 = key => {
        const storeIndex = key.number - 1;
        const keyMeasure = pianoMeasureState.keys[storeIndex] ?? {
          downWeightWithSpringSupport: null,
          downWeightWithoutSpringSupport: null,
          frontWeight: null,
          keyWeightRatio: null,
          measuredStrikeWeightRatio: null,
          strikeWeight: null,
          upWeight: null,
          wippenRadiusWeight: null
        };
        return computeKeyMeasurements(keyMeasure);
      };
      $[4] = computeKeyMeasurements;
      $[5] = pianoMeasureState;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = keyboard.map(t1);
    $[0] = computeKeyMeasurements;
    $[1] = keyboard;
    $[2] = pianoMeasureState;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const measuredKeyboard = t0;
  return measuredKeyboard;
};
function _temp(state) {
  return {
    keys: state.keys
  };
}